export interface ZeroErrorCorrection {
  observedReading: number;
  zeroError: number;
  correction: number;
  correctedReading: number;
}

/** Corrects a reading by subtracting the signed instrument zero error. */
export function correctZeroError(observedReading: number, zeroError: number): ZeroErrorCorrection {
  if (!Number.isFinite(observedReading) || !Number.isFinite(zeroError)) {
    throw new TypeError('Reading and zero error must be finite numbers.');
  }
  const correction = -zeroError;
  return { observedReading, zeroError, correction, correctedReading: observedReading + correction };
}

export function zeroCorrection(zeroError: number): number {
  if (!Number.isFinite(zeroError)) throw new TypeError('Zero error must be a finite number.');
  return -zeroError;
}